const pow = Math.pow;
export default pow;
